export default {
  ROOT_PATH: '',
  SERVICES_PATH: 'services',
  TASKS_PATH: 'tasks',
  JOBS_PATH: 'jobs',
  JOB_SEARCH_PATH: 'searchJobs',
  EVENTS_PATH: 'events'
};
